/** start: tracking event V2 **/

addEventListener('DOMContentLoaded', (event) => {
  /** variable **/
  if (!Utils.isCollectionPage) {
    const isCollectionPage = () => {
      return window.location.pathname.includes('/collections');
    };

    Utils.isCollectionPage = isCollectionPage;
  }

  if (window.Analytics) {
    var ANALYTICS_KEY = 'boostPFSAnalytics';
    var SESSION_KEY = 'boostPFSSessionId';
    var CLICKED_PRODUCT_KEY = 'boostPFSClickedProduct';
    var CART_TOKEN = '';
    var SESSION = '';
    var VIEWED_PRODUCT_DATA = null;
    var boostPFSRequestIds = 'boostPFSRequestIds';
    var AnalyticsEnum = {
      UserAction: {
        VIEW_PRODUCT: 'view_product',
        QUICK_VIEW: 'quick_view',
        ADD_TO_CART: 'add_to_cart',
        BUY_NOW: 'buy_now',
      },
      Action: {
        FILTER: 'filter',
        SEARCH: 'search',
        SUGGEST: 'suggest',
      },
    };

    /** utils function **/

    /**
     * Init analytics on instant search
     */
    Analytics.initInstantSearch = function () {
      if (Settings.getSettingValue('search.enableSuggestion')) {
        document.addEventListener('click', Analytics.onClickProductInSuggestion, true);
        document.addEventListener('keydown', Analytics.onClickProductInSuggestion, true);
      }
    };

    /**
     * Init analytics on collection/search page
     */
    Analytics.initCollectionSearchPage = function () {
      if (Selector.trackingProduct && jQ(Selector.products).length > 0) {
        document.addEventListener('click', Analytics.onClickProductInFilterResult, true);
      }
    };

    /**
     * Init analytics on product page.
     * Find and send a product click data in localStorage to server.
     */
    Analytics.initOtherPage = function () {
      // Send any analytics that was cancelled before it was sent
      var dataList = Analytics.getLocalStorage(ANALYTICS_KEY);
      if (!Array.isArray(dataList)) return;
      dataList.forEach((data) => {
        Analytics.sendProductClickData(data, true);
        if (data.pid == boostPFSAppConfig.general.product_id) {
          VIEWED_PRODUCT_DATA = data;
        }
      });

      /** If go to product page through our app, bind add to cart & buy now event **/
      if (Utils.isProductPage()) {
        if (Selector.trackingAddToCart) {
          document.addEventListener('click', Analytics.onClickAddToCartInProductPage, true);
        }
        if (Selector.trackingBuyNow) {
          document.addEventListener('click', Analytics.onClickBuyNowInProductPage, true);
        }
      }

      /** Because V2 use Recommendation of V3 so We will listen event clicked to productItem in Recommendation widget
       * Remove this product in clicked data for v2 only tracking add_to_cart, buy_now use v3 when click from here
       * avoid duplicate event add_to_cart, buy_now
       */
      document.addEventListener('click', Analytics.detectClickFromRecommendation, true);
    };

    Analytics.refreshCartToken = function (dataToRetry, retryCount = 3) {
      if (retryCount <= 0) {
        return;
      }

      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          /*** min length token valid => 58, if < 58 token empty **/
          if (data.token && data.token.length > 58) {
            CART_TOKEN = data.token;
            if (dataToRetry) {
              dataToRetry.ct = data.token;
              Analytics.sendProductClickData(dataToRetry, true);
            }
          } else {
            setTimeout(() => Analytics.refreshCartToken(dataToRetry, retryCount - 1), 1000);
          }
        })
        .catch((error) => {
          setTimeout(() => Analytics.refreshCartToken(dataToRetry, retryCount - 1), 1000);
        });
    };

    /**
     * Generates a random unique session ID
     * @return {string} random unique ID
     */
    Analytics.generateUUID = function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    };

    /**
     * Handle analytic on click product list in the collection/search page.
     * Save the clicked product data to localStorage.
     * @param {Event} event - the click event
     */
    Analytics.onClickProductInFilterResult = function (event) {
      if (!event || !event.target) return;
      var $clickedElement = jQ(event.target);

      var action = Utils.isSearchPage() ? AnalyticsEnum.Action.SEARCH : AnalyticsEnum.Action.FILTER;
      var userAction = AnalyticsEnum.UserAction.VIEW_PRODUCT;
      if (
        Selector.trackingQuickView &&
        $clickedElement.closest(Selector.trackingQuickView).length > 0
      ) {
        userAction = AnalyticsEnum.UserAction.QUICK_VIEW;
      }
      if (
        (Selector.trackingAddToCart &&
          $clickedElement.closest(Selector.trackingAddToCart).length > 0) ||
        ($clickedElement.closest(Selector.products).length > 0 &&
          Analytics.isClickAddToCart(event.target))
      ) {
        userAction = AnalyticsEnum.UserAction.ADD_TO_CART;
      }
      if (Selector.trackingBuyNow && $clickedElement.closest(Selector.trackingBuyNow).length > 0) {
        userAction = AnalyticsEnum.UserAction.BUY_NOW;
      }

      /** If the user clicked quickview button,
       * and then click add to cart/buy now within the quick view modal,
       * but the modal is outside of the product grid item,
       * we'll use the last clicked id from the quick view event
       **/
      var productId = '';
      var $productElement = $clickedElement.closest(Selector.trackingProduct);
      /** If found product grid item **/
      if ($productElement.length > 0) {
        productId = $productElement.attr('data-id');
        /** If not found product grid item, maybe we're inside a quickview modal. **/
      } else if (VIEWED_PRODUCT_DATA) {
        /** Add to cart and buy now within modal **/
        if (
          userAction == AnalyticsEnum.UserAction.ADD_TO_CART ||
          userAction == AnalyticsEnum.UserAction.BUY_NOW
        ) {
          productId = VIEWED_PRODUCT_DATA.pid;
        }
      }
      if (!productId) return;

      var data = Analytics.buildProductClickData(productId, userAction, action);
      Analytics.addProductClickData(data);
      Analytics.sendProductClickData(data, true);

      if (userAction == AnalyticsEnum.UserAction.QUICK_VIEW) {
        VIEWED_PRODUCT_DATA = data;
      } else {
        VIEWED_PRODUCT_DATA = null;
      }
    };

    /**
     * Handle analytic on click product in search suggestion.
     * Save the clicked product data to localStorage.
     * @param {Event} event - the click event
     */
    Analytics.onClickProductInSuggestion = function (event) {
      if (!event || !event.target) return;

      /** Check for keyboard enter event **/
      if (event.type == 'keydown' && event.keyCode != 13) return;

      var $clickedElement = jQ(event.target);
      var $productElement = $clickedElement.closest('.' + Class.searchSuggestionItem + '-product');
      if (!$productElement) return;

      var productId = $productElement.attr('data-id');
      if (!productId) return;

      var data = Analytics.buildProductClickData(
        productId,
        AnalyticsEnum.UserAction.VIEW_PRODUCT,
        AnalyticsEnum.Action.SUGGEST
      );
      Analytics.addProductClickData(data);
    };

    Analytics.isClickAddToCart = function (activeElement) {
      if (!activeElement) return false;
      if (
        ['SPAN', 'XVG'].includes(activeElement.tagName) &&
        activeElement.parentElement?.tagName === 'BUTTON'
      ) {
        activeElement = activeElement.parentElement;
      }

      const addToCartKeywords = [
        'boost-pfs-addtocart-btn',
        'customizeAdd',
        'add to cart',
        'add-to-cart',
        'add to bag',
        'add_to_cart',
        'addtocart',
        'data-product-form-add',
        'name="add"',
        'add to basket',
        'atc-button',
      ];

      const innerText = activeElement?.outerHTML?.toLowerCase() || '';

      return addToCartKeywords.some((keyword) => innerText.includes(keyword));
    };

    Analytics.onClickAddToCartInProductPage = function (event) {
      if (
        event &&
        event.target &&
        (jQ(event.target).closest(Selector.trackingAddToCart).length > 0 ||
          Analytics.isClickAddToCart(event.target))
      ) {
        var data = {
          tid: Globals.shopDomain,
          pid: boostPFSAppConfig.general.product_id.toString(),
          ct: CART_TOKEN,
          r: document.referrer,
          u: AnalyticsEnum.UserAction.ADD_TO_CART,
        };

        var productClickedData = Analytics.getLocalStorage(CLICKED_PRODUCT_KEY) || {};

        if (productClickedData[boostPFSAppConfig.general.product_id]) {
          data = Object.assign(productClickedData[boostPFSAppConfig.general.product_id], data);
          Analytics.addProductClickData(data);
          Analytics.sendProductClickData(data);
        }
      }
    };

    Analytics.onClickBuyNowInProductPage = function (event) {
      if (event && event.target && jQ(event.target).closest(Selector.trackingBuyNow).length > 0) {
        var data = {
          tid: Globals.shopDomain,
          pid: boostPFSAppConfig.general.product_id.toString(),
          u: AnalyticsEnum.UserAction.BUY_NOW,
          ct: CART_TOKEN,
        };

        var productClickedData = Analytics.getLocalStorage(CLICKED_PRODUCT_KEY) || {};

        if (productClickedData[boostPFSAppConfig.general.product_id]) {
          data = productClickedData[boostPFSAppConfig.general.product_id];
          data.u = AnalyticsEnum.UserAction.BUY_NOW;
          Analytics.addProductClickData(data);
          Analytics.sendProductClickData(data);
        }
      }
    };

    /**
     * Build product click data in collection/search page and in instant search.
     * @param {Number} productId
     * @param {AnalyticsEnum.UserAction} userAction - UserAction enum
     * @param {AnalyticsEnum.Action} action - Action enum
     * @return {Object} data - the click data to be add to localStorage/send to server.
     */
    Analytics.buildProductClickData = (productId, userAction, action) => {
      var currentTime = new Date();

      /** Get cart token from global **/
      var cartToken = CART_TOKEN;

      /** Merge quick_view and view_product when sending to backend **/
      var mergeUserAction =
        userAction == AnalyticsEnum.UserAction.QUICK_VIEW
          ? AnalyticsEnum.UserAction.VIEW_PRODUCT
          : userAction;

      /** Get query string data **/
      var queryString = '';
      if (action == AnalyticsEnum.Action.FILTER) {
        queryString += 'collection_scope=' + Globals.collectionId;
      } else {
        queryString += 'q=' + Globals.currentTerm;
      }
      if (action == AnalyticsEnum.Action.FILTER || action == AnalyticsEnum.Action.SEARCH) {
        var filteredKeys = Object.keys(Globals.queryParams).filter((key) =>
          key.startsWith(Globals.prefix)
        );
        if (filteredKeys && filteredKeys.length > 0) {
          filteredKeys.forEach((key) => {
            var values = Globals.queryParams[key];
            if (Array.isArray(values)) {
              values.forEach((value) => {
                queryString += '&' + key + '=' + encodeURIComponent(value);
              });
            } else {
              queryString += '&' + key + '=' + encodeURIComponent(values);
            }
          });
        }
      }

      var requestIds = Analytics.getLocalStorage(boostPFSRequestIds);

      /** Build data **/
      var data = {
        tid: Globals.shopDomain,
        ct: cartToken,
        pid: productId,
        t: currentTime.toISOString(),
        u: mergeUserAction,
        a: action,
        qs: queryString,
        r: document.referrer,
        rid: requestIds[action]?.rid,
      };

      /** save productClickedData key **/
      var preValue = Analytics.getLocalStorage(CLICKED_PRODUCT_KEY) || {};

      Analytics.setLocalStorage(CLICKED_PRODUCT_KEY, {
        [productId]: {
          ...data,
        },
        ...preValue,
      });

      return data;
    };

    /** catch event when click productItem in Recommendation **/
    Analytics.detectClickFromRecommendation = function (event) {
      if (!event || !event.target) return;

      var $clickedElement = jQ(event.target);
      var productItemV3 = $clickedElement.closest('.boost-sd__product-item');
      if (productItemV3.length > 0) {
        var productId = productItemV3[0].id;
        var variantId = productItemV3[0]['data-product-id'];

        productId && Analytics.removeProductIdClickedProductItemInRecommendation(productId);
        variantId && Analytics.removeProductIdClickedProductItemInRecommendation(variantId);
      }
    };

    /** Remove productId from Object CLICKED_PRODUCT_KEY avoid duplicate event when v2 use recommendation **/
    Analytics.removeProductIdClickedProductItemInRecommendation = function (productId) {
      var preValue = Analytics.getLocalStorage(CLICKED_PRODUCT_KEY) || {};

      delete preValue[productId];

      Analytics.setLocalStorage(CLICKED_PRODUCT_KEY, {
        ...preValue,
      });
    };

    /**
     * Add product click data in local storage.
     * @param {Object} data - product click data
     */
    Analytics.addProductClickData = function (data) {
      /** Get data list from local storage **/
      var dataList = Analytics.getLocalStorage(ANALYTICS_KEY);
      if (!Array.isArray(dataList)) dataList = [];

      /** Add new data to the list, without duplicated id **/
      var newDataList = dataList.filter((x) => x.pid != data.productId);
      newDataList.push(data);

      Analytics.setLocalStorage(ANALYTICS_KEY, newDataList);
    };

    Analytics.removeProductClickData = function (productId) {
      /** Get data list from local storage **/
      var dataList = Analytics.getLocalStorage(ANALYTICS_KEY);
      if (!Array.isArray(dataList)) return;

      /** Filter for products that doesn't match the id **/
      var newDataList = dataList.filter((x) => x.pid != productId);
      Analytics.setLocalStorage(ANALYTICS_KEY, newDataList);
    };

    Analytics.getLocalStorage = function (key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch {
        return null;
      }
    };

    Analytics.setLocalStorage = function (key, value) {
      try {
        if (value != null) {
          localStorage.setItem(key, JSON.stringify(value));
        } else {
          localStorage.setItem(key, '');
        }
      } catch {}
    };

    /**
     * Send product click data to server.
     * @param {Object} data - product click data
     * @param {boolean} triedToGetToken - tried to get cart token by calling cart.js or not
     */
    Analytics.sendProductClickData = function (data, triedToGetToken) {
      if (!data.rid) return;
      /** addToCart or BuyNow refresh cartToken  **/
      if (
        [AnalyticsEnum.UserAction.ADD_TO_CART, AnalyticsEnum.UserAction.BUY_NOW].includes(data.u)
      ) {
        triedToGetToken = false;
      }
      if (!triedToGetToken && !data.ct) {
        setTimeout(function () {
          Analytics.refreshCartToken(data);
        }, 1000);
        return;
      }

      data.sid = SESSION;

      Analytics.removeProductClickData(data.pid);

      /** Set up HTTP request **/
      var xhr = new XMLHttpRequest();
      xhr.open('POST', Api.getApiUrl('analytics'));
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.send(JSON.stringify(data));
    };

    Analytics.getSessionId = function () {
      if (SESSION) {
        return SESSION;
      } else {
        SESSION = Analytics.getLocalStorage(SESSION_KEY);
      }
      if (!SESSION) {
        SESSION = Analytics.generateUUID();
        Analytics.setLocalStorage(SESSION_KEY, SESSION);
      }
      return SESSION;
    };

    /** customize function **/
    if (Utils.isSearchPage() || (Utils.isCollectionPage() && !Utils.isProductPage())) {
      FilterApi.afterCall = function (result, eventType, eventInfo) {
        var key = AnalyticsEnum.Action.FILTER;
        if (Utils.isSearchPage()) {
          key = AnalyticsEnum.Action.SEARCH;
        }

        var preValue = Analytics.getLocalStorage(boostPFSRequestIds) || {};

        Analytics.setLocalStorage(boostPFSRequestIds, {
          ...preValue,
          [key]: {
            rid: result?.meta?.rid,
            data: result,
          },
        });
      };
    }

    InstantSearchApi.afterCall = function (result) {
      var preValue = Analytics.getLocalStorage(boostPFSRequestIds) || {};

      Analytics.setLocalStorage(boostPFSRequestIds, {
        ...preValue,
        [AnalyticsEnum.Action.SUGGEST]: {
          rid: result?.meta?.rid,
          data: result,
        },
      });
    };

    Analytics.init = function () {
      if (!window.XMLHttpRequest) return;

      CART_TOKEN = '';
      SESSION = Analytics.getLocalStorage(SESSION_KEY);
      if (!SESSION) {
        SESSION = Analytics.generateUUID();
        Analytics.setLocalStorage(SESSION_KEY, SESSION);
      }

      Analytics.initInstantSearch();
      Analytics.initCollectionSearchPage();
      Analytics.initOtherPage();
    };

    window.Analytics = Analytics;

    setTimeout(function awaitTriggerDone() {
      Analytics?.init();
      console.log('Have customize tracking events for analytics V2');
    }, 1000);
  } else {
    console.log('This page have not tracking events for analytics V2');
  }
});
let srrInterval = setInterval(function () {
  let foundCurrency = false;
  const isArabicPage = window.location.href.includes('/ar');

  document.querySelectorAll(".boost-pfs-filter-product-item-regular-price").forEach(function (el) {
    const saleSpan = el.querySelector(".boost-pfs-filter-product-item-sale-price");
    const strikeEl = saleSpan ? saleSpan.querySelector("s") : null;

    function cleanCurrency(target) {
      if (!target) return;

      if (/\bSR\b/i.test(target.textContent) || /رس/g.test(target.textContent)) {
        foundCurrency = true;
        target.textContent = target.textContent
          .replace(/\bSR\b/gi, "")
          .replace(/رس/g, "")
          .replace(/\s+/g, " ")
          .trim();
      }
    }

    function addImage(target) {
      if (!target) return;
      if (target.querySelector(".custom-price-icon")) return;

      let img = document.createElement("img");
      img.src = "https://cdn.shopify.com/s/files/1/0732/1691/7807/files/Isolation_Mode_17.svg?v=1775981835";
      img.className = "custom-price-icon";
      img.style.width = "21px";
      img.style.height = "25px";
      img.style.marginLeft = "5px";
      img.style.marginRight = "5px";
      img.style.verticalAlign = "middle";

      if (isArabicPage) {
        target.appendChild(img);
      } else {
        target.prepend(img);
      }
    }

    // main regular price
    cleanCurrency(el);
    addImage(el);

    // sale price span
    cleanCurrency(saleSpan);
    addImage(saleSpan);

    // old compare price inside s
    cleanCurrency(strikeEl);
    addImage(strikeEl);
  });
}, 500);




let currencyWatcher = setInterval(function () {
  let currencyFound = false;
  const isArabicUrl = window.location.href.includes('/ar');

  function removeCurrencyText(priceNode) {
    if (!priceNode) return;

    if (/\bSR\b/i.test(priceNode.textContent) || /رس/g.test(priceNode.textContent)) {
      currencyFound = true;
      priceNode.textContent = priceNode.textContent
        .replace(/\bSR\b/gi, "")
        .replace(/رس/g, "")
        .replace(/\s+/g, " ")
        .trim();
    }
  }

  function insertCurrencyIcon(priceNode, iconSrc, iconClass) {
    if (!priceNode || priceNode.querySelector("." + iconClass)) return;

    let currencyIcon = document.createElement("img");
    currencyIcon.src = iconSrc;
    currencyIcon.className = iconClass;
    currencyIcon.style.width = "12px";
    currencyIcon.style.height = "16px";
    currencyIcon.style.marginLeft = "5px";
    currencyIcon.style.marginRight = "5px";
    currencyIcon.style.verticalAlign = "middle";

    if (isArabicUrl) {
      priceNode.appendChild(currencyIcon);
    } else {
      priceNode.prepend(currencyIcon);
    }
  }

  document.querySelectorAll(".boost-pfs-filter-product-item-sale-price").forEach(function (salePriceNode) {
    const oldPriceNode = salePriceNode.parentElement ? salePriceNode.parentElement.querySelector("s") : null;

    removeCurrencyText(salePriceNode);
    insertCurrencyIcon(
      salePriceNode,
      "https://cdn.shopify.com/s/files/1/0732/1691/7807/files/Isolation_Mode_22.svg?v=1776378980",
      "custom-sale-price-icon"
    );

    if (oldPriceNode) {
      removeCurrencyText(oldPriceNode);
      insertCurrencyIcon(
        oldPriceNode,
        "https://cdn.shopify.com/s/files/1/0732/1691/7807/files/Isolation_Mode_18.svg?v=1775993201",
        "bah"
      );
    }
  });

  if (!currencyFound) {
    
  }
}, 500);
function wrapPricesAndAddSaleLabel() {
  document.querySelectorAll(".boost-pfs-filter-product-item-price").forEach(function (priceWrapper) {
    const salePriceNode = priceWrapper.querySelector(".boost-pfs-filter-product-item-sale-price");
    const oldPriceNode = priceWrapper.querySelector("s");

    if (!salePriceNode || !oldPriceNode) return;

    let pricesRow = priceWrapper.querySelector(".custom-price-row");

    if (!pricesRow) {
      pricesRow = document.createElement("div");
      pricesRow.className = "custom-price-row";
      pricesRow.style.display = "flex";
      pricesRow.style.flexDirection = "column";

      priceWrapper.insertBefore(pricesRow, priceWrapper.firstChild);
      pricesRow.appendChild(salePriceNode);
      pricesRow.appendChild(oldPriceNode);
    }

    if (!priceWrapper.querySelector(".custom-sale-percent")) {
      const salePrice = parseFloat(salePriceNode.textContent.replace(/[^\d.]/g, ""));
      const oldPrice = parseFloat(oldPriceNode.textContent.replace(/[^\d.]/g, ""));

      if (isNaN(salePrice) || isNaN(oldPrice) || oldPrice <= salePrice) return;

      const discountPercent = Math.round(((oldPrice - salePrice) / oldPrice) * 100);

      const percentDiv = document.createElement("div");
      percentDiv.className = "custom-sale-percent";
      percentDiv.textContent = discountPercent + "% SALE";

      percentDiv.style.width = "82.91px";
      percentDiv.style.height = "23.905px";
      percentDiv.style.borderRadius = "6px 0 0 6px";
      percentDiv.style.background = "#FFEB06";
      percentDiv.style.color = "#0E3968";
      percentDiv.style.fontFamily = "Rubik";
      percentDiv.style.fontSize = "13px";
      percentDiv.style.fontStyle = "normal";
      percentDiv.style.fontWeight = "700";
      percentDiv.style.lineHeight = "120%";
      percentDiv.style.letterSpacing = "0.13px";
      percentDiv.style.display = "flex";
      percentDiv.style.alignItems = "center";
      percentDiv.style.justifyContent = "center";
      percentDiv.style.marginTop = "6px";

      priceWrapper.appendChild(percentDiv);
    }
  });
}

setInterval(function () {
  wrapPricesAndAddSaleLabel();
}, 500);

// function mapFormsToButtons() {
//   const forms = document.querySelectorAll('.boost-pfs-addtocart-product-form');
//   const buttons = document.querySelectorAll('.button-ff');

//   // ✅ Move forms (only once)
//   forms.forEach(function (form, index) {
//     const targetDiv = buttons[index];
//     if (!targetDiv) return;

//     if (form.dataset.moved === "true") return;

//     targetDiv.appendChild(form);
//     form.dataset.moved = "true";
//   });

//   // ✅ Update ALL buttons text
//   const allButtons = document.querySelectorAll('.boost-pfs-addtocart-select-options');

//   allButtons.forEach(function (btn) {
//     const textSpan = btn.querySelector('.boost-pfs-addtocart-btn-text');

//     if (!textSpan) return;

//     const spanText = textSpan.innerText.toLowerCase();
//     const btnText = btn.innerText.toLowerCase();

//     // 🟥 If SOLD OUT → append "Sold Out"
//     if (spanText.includes('sold out')) {
//       if (!btnText.includes('sold out')) {
//         btn.append(' Sold Out');
//       }
//       return;
//     }

//     // 🟩 Otherwise → append "Add to Cart"
//     if (!btnText.includes('add to cart')) {
//       btn.append(' Add to Cart');
//     }
//   });
// }

// // Run every 2 seconds
// setInterval(mapFormsToButtons, 2000);

// // Run once immediately
// mapFormsToButtons();


// function handleBoostUI() {
//   const forms = document.querySelectorAll('.boost-pfs-addtocart-product-form');
//   const buttons = document.querySelectorAll('.button-ff');

//   forms.forEach(function (form, index) {
//     const targetDiv = buttons[index];
//     if (!targetDiv) return;

//     // Move once
//     if (form.dataset.moved !== "true") {
//       targetDiv.appendChild(form);
//       form.dataset.moved = "true";
//     }

//     // Bind once
//     if (form.dataset.cartBound === "1") return;
//     form.dataset.cartBound = "1";

//     form.addEventListener("submit", function () {
//       // set flag BEFORE Magento AJAX runs
//       sessionStorage.setItem("go_to_cart_after_submit", "1");
//     });

//     // Button text logic
//     const btn = form.querySelector('.boost-pfs-addtocart-select-options');
//     const span = form.querySelector('.boost-pfs-addtocart-btn-text');

//     if (btn && span) {
//       const spanText = span.innerText.toLowerCase();
//       const btnText = btn.innerText.toLowerCase();

//       if (spanText.includes('sold out')) {
//         if (!btnText.includes('sold out')) {
//           btn.append(' Sold Out');
//         }
//       } else {
//         if (!btnText.includes('add to cart')) {
//           btn.append(' Add to Cart');
//         }
//       }
//     }

//   });
// }

// // Run UI handler
// setInterval(handleBoostUI, 2000);
// handleBoostUI();


// // ✅ Detect Magento AJAX success and redirect AFTER it finishes
// document.addEventListener("ajaxComplete", function () {
//   if (sessionStorage.getItem("go_to_cart_after_submit") !== "1") return;

//   // small delay to ensure cart data is updated
//   setTimeout(function () {
//     sessionStorage.removeItem("go_to_cart_after_submit");

//     // ✅ Force full reload of cart page
//     window.location.href = "/cart?reload=" + Date.now();

//   }, 300);
// });

// function mapFormsToButtons() {
//   const forms = document.querySelectorAll('.boost-pfs-addtocart-product-form');
//   const buttons = document.querySelectorAll('.button-ff');

//   // ✅ Move forms (only once)
//   forms.forEach(function (form, index) {
//     const targetDiv = buttons[index];
//     if (!targetDiv) return;

//     if (form.dataset.moved === "true") return;

//     targetDiv.appendChild(form);
//     form.dataset.moved = "true";
//   });

//   // ✅ Update ALL buttons text
//   const allButtons = document.querySelectorAll('.boost-pfs-addtocart-select-options');

//   allButtons.forEach(function (btn) {
//     const textSpan = btn.querySelector('.boost-pfs-addtocart-btn-text');
//     if (!textSpan) return;

//     const spanText = textSpan.innerText.toLowerCase();
//     const btnText = btn.innerText.toLowerCase();

//     // 🟥 SOLD OUT
//     if (spanText.includes('sold out')) {
//       if (!btnText.includes('sold out')) {
//         btn.append(' Sold Out');
//       }
//     } else {
//       // 🟩 ADD TO CART
//       if (!btnText.includes('add to cart')) {
//         btn.append(' Add to Cart');
//       }
//     }

//     // ✅ Replace with clean submit button (no classes)
//     if (btn.dataset.replaced === "true") return;

//     const form = btn.closest('form');
//     if (!form) return;

//     const newBtn = document.createElement('button');
//     newBtn.type = 'submit';

//     // ❌ REMOVE ALL CLASSES → do NOT copy className

//     // keep id/name if needed
//     if (btn.id) newBtn.id = btn.id;
//     if (btn.name) newBtn.name = btn.name;

//     // ✅ KEEP INNER HTML
//     newBtn.innerHTML = btn.innerHTML;

//     // replace
//     btn.replaceWith(newBtn);

//     newBtn.dataset.replaced = "true";
//   });
// }

// // Run every 2 seconds
// setInterval(mapFormsToButtons, 2000);

// // Run once immediately
// mapFormsToButtons();


// function mapFormsToButtons() {
//   const forms = document.querySelectorAll('.boost-pfs-addtocart-product-form');
//   const buttons = document.querySelectorAll('.button-ff');

//   forms.forEach(function (form, index) {
//     const targetDiv = buttons[index];
//     if (!targetDiv) return;

//     if (form.dataset.rebuilt === "true") return;

//     const oldIdInput = form.querySelector('input[name="id"]');
//     const oldIdValue = oldIdInput ? oldIdInput.value : '';

//     const newForm = document.createElement('form');
//     newForm.action = '/cart/add';
//     newForm.method = 'post';
//     newForm.enctype = 'multipart/form-data';
//     newForm.className = form.className;

//     const hiddenInput = document.createElement('input');
//     hiddenInput.type = 'hidden';
//     hiddenInput.name = 'id';
//     hiddenInput.value = oldIdValue;
//     hiddenInput.tabIndex = 0;

//     const button = document.createElement('button');
//     button.type = 'submit';
//     button.className = 'button-grid';
//     button.tabIndex = 0;
//     button.style.cssText = `
//       width: 257.842px;
//       height: 31.795px;
//       flex-shrink: 0;
//       border-radius: 8.167px;
//       background: #1390FC;
//       color: #FFF;
//       font-family: Poppins;
//       font-size: 15.423px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 120%;
//       letter-spacing: 0.154px;
//       border: none;
//       cursor: pointer;
//     `;

//     const oldTextSpan = form.querySelector('.boost-pfs-addtocart-btn-text');
//     const oldText = oldTextSpan ? oldTextSpan.innerText.toLowerCase() : form.innerText.toLowerCase();

//     if (oldText.includes('sold out')) {
//       button.textContent = 'Sold Out';
//       button.disabled = true;
//       button.style.background = '#B0B0B0';
//       button.style.cursor = 'not-allowed';
//       button.style.opacity = '0.7';
//     } else if (oldText.includes('نفذ')) {
//       button.textContent = 'نفذ';
//       button.disabled = true;
//       button.style.background = '#B0B0B0';
//       button.style.cursor = 'not-allowed';
//       button.style.opacity = '0.7';
//     } else {
//       button.textContent = 'Add to Cart';
//     }

//     newForm.appendChild(hiddenInput);
//     newForm.appendChild(button);

//     targetDiv.innerHTML = '';
//     targetDiv.appendChild(newForm);

//     form.dataset.rebuilt = "true";
//   });
// }

// setInterval(mapFormsToButtons, 2000);

let mapFormsInterval = setInterval(function () {
  const originalForms = document.querySelectorAll('.boost-pfs-addtocart-product-form');
  const targetButtons = document.querySelectorAll('.button-ff');
  let doneCount = 0;

  originalForms.forEach(function (originalForm, index) {
    const targetBox = targetButtons[index];
    if (!targetBox) return;

    if (targetBox.dataset.formMatched === "true") {
      doneCount++;
      return;
    }

    const originalIdInput = originalForm.querySelector('input[name="id"]');
    const originalIdValue = originalIdInput ? originalIdInput.value : '';

    const oldTextSpan = originalForm.querySelector('.boost-pfs-addtocart-btn-text');
    const oldText = oldTextSpan
      ? oldTextSpan.innerText.toLowerCase()
      : originalForm.innerText.toLowerCase();

    const newForm = document.createElement('form');
    newForm.action = '/cart/add';
    newForm.method = 'post';
    newForm.enctype = 'multipart/form-data';
    newForm.className = '';

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'id';
    hiddenInput.value = originalIdValue;
    hiddenInput.tabIndex = 0;

    const submitButton = document.createElement('button');
    submitButton.className = 'button-grid product-form__cart-submit';
    submitButton.style.cssText = 'width: 257.842px;height: 31.795px;flex-shrink: 0;border-radius: 8.167px;background: #1390FC;color: #FFF;font-family: Poppins;font-size: 15.423px;font-style: normal;font-weight: 700;line-height: 120%;letter-spacing: 0.154px;border:none';
    submitButton.type = 'submit';
    submitButton.tabIndex = 0;

    if (oldText.includes('sold out')) {
      submitButton.textContent = 'Sold Out';
      submitButton.disabled = true;
      submitButton.style.background = '#B0B0B0';
      submitButton.style.cursor = 'not-allowed';
      submitButton.style.opacity = '0.7';
    } else if (oldText.includes('نفذ')) {
      submitButton.textContent = 'نفذ';
      submitButton.disabled = true;
      submitButton.style.background = '#B0B0B0';
      submitButton.style.cursor = 'not-allowed';
      submitButton.style.opacity = '0.7';
    } else {
      submitButton.textContent = 'Add to Cart';
    }

    newForm.appendChild(hiddenInput);
    newForm.appendChild(submitButton);

    targetBox.innerHTML = '';
    targetBox.appendChild(newForm);
    targetBox.dataset.formMatched = "true";

    doneCount++;
  });

  if (doneCount === originalForms.length && originalForms.length > 0) {
  
  }
}, 500);


function moveWishlistAboveProductInner() {
  const wishlistItems = document.querySelectorAll(".addto-wishlist");
  const productInners = document.querySelectorAll(".boost-pfs-filter-product-item-inner");

  wishlistItems.forEach(function (wishlistItem, index) {
    const targetInner = productInners[index];
    if (!targetInner) return;

    if (wishlistItem.dataset.moved === "true") return;

    targetInner.parentNode.insertBefore(wishlistItem, targetInner);
    wishlistItem.dataset.moved = "true";
  });
}

setInterval(function () {
  moveWishlistAboveProductInner();
}, 500);

function addIncludingVAT() {
  const priceParagraphs = document.querySelectorAll(".boost-pfs-filter-product-item-price");

  priceParagraphs.forEach(function (p) {
    if (p.querySelector(".including-vat-text")) return;

    const priceSpan = p.querySelector(".boost-pfs-filter-product-item-regular-price");
    if (!priceSpan) return;

    const vatSpan = document.createElement("span");
    vatSpan.className = "including-vat-text";
    vatSpan.textContent = "Including VAT";
    vatSpan.style.marginLeft = "6px";
    vatSpan.style.color = "#808285";
    vatSpan.style.fontFamily = "Rubik";
    vatSpan.style.fontSize = "11.293px";
    vatSpan.style.fontStyle = "normal";
    vatSpan.style.fontWeight = "400";
    vatSpan.style.lineHeight = "120%";
    vatSpan.style.letterSpacing = "0.113px";
    vatSpan.style.display = "inline-block";
    vatSpan.style.verticalAlign = "middle";
    vatSpan.style.setProperty("text-transform", "none", "important");

    priceSpan.insertAdjacentElement("afterend", vatSpan);
  });
}

setInterval(addIncludingVAT, 1000);


function addIncludingVAT() {
  const isArabicPage = window.location.href.includes("/ar");

  const priceParagraphs = document.querySelectorAll(".boost-pfs-filter-product-item-price");

  priceParagraphs.forEach(function (p) {
    if (p.querySelector(".including-vat-text")) return;

    const vatSpan = document.createElement("span");
    vatSpan.className = "including-vat-text";
    vatSpan.textContent = "Including VAT";
    vatSpan.style.marginLeft = "6px";
    vatSpan.style.color = "#808285";
    vatSpan.style.fontFamily = "Rubik";
    vatSpan.style.fontSize = "11.293px";
    vatSpan.style.fontStyle = "normal";
    vatSpan.style.fontWeight = "400";
    vatSpan.style.lineHeight = "120%";
    vatSpan.style.letterSpacing = "0.113px";
    vatSpan.style.display = "inline-block";
    vatSpan.style.verticalAlign = "middle";
    vatSpan.style.setProperty("text-transform", "none", "important");

    if (p.querySelector("s")) {
      vatSpan.style.position = "relative";

      if (isArabicPage) {
        vatSpan.style.left = "5px";
      } else {
        vatSpan.style.right = "5px";
      }
    }

    p.appendChild(vatSpan);
  });
}

setInterval(addIncludingVAT, 1000);

function updatePriceLayoutOnMobile() {
  const isMobile = window.innerWidth <= 480;
  const priceElements = document.querySelectorAll(".boost-pfs-filter-product-item-price");

  priceElements.forEach(function (priceEl) {
    if (priceEl.querySelector("s") && isMobile) {
      priceEl.style.display = "flex";
      priceEl.style.flexDirection = "row";
      priceEl.style.alignItems = "center";
      priceEl.style.gap = "6px";
    } else {
      priceEl.style.display = "";
      priceEl.style.flexDirection = "";
      priceEl.style.alignItems = "";
      priceEl.style.gap = "";
    }
  });
}

setInterval(updatePriceLayoutOnMobile, 1000);

if (window.location.href.includes("collections")) {
  const isArabicPage = window.location.href.includes("/ar");

  setInterval(function () {
    document.querySelectorAll(".slick-track").forEach(function (el) {
      el.style.height = "150px";

      if (isArabicPage) {
     
      } else {
        el.style.transform = "";
      }
    });

    document.querySelectorAll(".slick-prev, .slick-next").forEach(function (arrow) {
      if (isArabicPage && window.innerWidth <= 767) {
        arrow.style.transform = "scaleX(-1)";
      } else {
        arrow.style.transform = "";
      }
    });

    document.querySelectorAll(".slick-prev").forEach(function (prevArrow) {
      prevArrow.style.left = "15px";
    });

    document.querySelectorAll(".slick-next").forEach(function (nextArrow) {
      nextArrow.style.right = "15px";
    });
  }, 1000);
}if (window.location.href.includes("collections")) {
  const isArabicPage = window.location.href.includes("/ar");

  setInterval(function () {
    document.querySelectorAll(".slick-track").forEach(function (el) {
      el.style.height = "150px";

      if (isArabicPage) {
      
      } else {
        el.style.transform = "";
      }
    });

    document.querySelectorAll(".slick-prev, .slick-next").forEach(function (arrow) {
      if (isArabicPage) {
        arrow.style.transform = "scaleX(-1)";
      } else {
        arrow.style.transform = "";
      }
    });

    document.querySelectorAll(".slick-prev").forEach(function (prevArrow) {
      prevArrow.style.left = "15px";
    });

    document.querySelectorAll(".slick-next").forEach(function (nextArrow) {
      nextArrow.style.right = "15px";
    });
  }, 1000);
}



setInterval(function () {
  if (!window.location.pathname.includes('/ar')) return;

  var form = document.querySelector('.button-ff form');
  if (!form) return;

  var action = form.getAttribute('action') || '';
  if (!action) return;

  if (action.includes('/ar/cart/add')) return;

  if (action.includes('/cart/add')) {
    form.setAttribute('action', action.replace('/cart/add', '/ar/cart/add'));
  }
}, 500);

setInterval(function() {
    // Only apply on mobile
    if (window.innerWidth < 767) {

        var isArabic = window.location.href.includes('/ar');

        if (!isArabic) {
            // including-vat-text
            document.querySelectorAll('.including-vat-text').forEach(function(el) {
                el.style.left = '2px';
                el.style.right = '0';
            });

            // custom-sale-price-icon (non-AR)
            document.querySelectorAll('.custom-sale-price-icon').forEach(function(el) {
                el.style.marginRight = '0';
                el.style.marginLeft = '';
            });

        } else {
            // custom-sale-price-icon (AR)
            document.querySelectorAll('.custom-sale-price-icon').forEach(function(el) {
                el.style.marginRight = '';
                el.style.marginLeft = '10px';
            });
        }

        // font size for sale price
        document.querySelectorAll('.boost-pfs-filter-product-item-sale-price').forEach(function(el) {
            el.style.fontSize = '18px';
        });
    }
}, 500);



setInterval(function () {
  if (window.location.pathname.indexOf('/ar/search') === -1) return;

  document.querySelectorAll('.boost-pfs-filter-product-item-price s').forEach(function (el) {
    el.style.setProperty('margin', '-2px 0 0 0', 'important');
  });

  document.querySelectorAll('.including-vat-text').forEach(function (el) {
    el.style.setProperty('font-size', '5.293px', 'important');
    el.style.setProperty('margin-right', '2px', 'important');
  });

  document.querySelectorAll('.custom-sale-percent').forEach(function (el) {
    el.style.setProperty('width', '50.91px', 'important');
    el.style.setProperty('font-size', '9px', 'important');
  });
}, 300);
setInterval(function () {
  if (window.location.pathname.indexOf('/search') === -1) return;

  document.querySelectorAll('.boost-pfs-filter-product-item-price s').forEach(function (el) {
    el.style.setProperty('margin', '-2px 0 0 0', 'important');
  });

  document.querySelectorAll('.including-vat-text').forEach(function (el) {
    el.style.setProperty('font-size', '5.293px', 'important');
    el.style.setProperty('margin-right', '2px', 'important');
        el.style.setProperty('margin-left', '3px', 'important');
  });

  document.querySelectorAll('.custom-sale-percent').forEach(function (el) {
    el.style.setProperty('width', '50.91px', 'important');
    el.style.setProperty('font-size', '9px', 'important');
  });
}, 300);